import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { PostComment } from "../../models/post-comment.model";

@Injectable()
export class PostCommentProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  comments(id: number): Observable<PostComment[]> {
    return this.http
      .get<PostComment[]>(`${this.url}/post-comments/comments/${id}`)
      .map(response => {
        return response.map(comment => new PostComment(comment));
      })
      .catch(this.handleError)
  }

  postComment(commentValues: Object): Observable<PostComment[]> {
    return this.http
      .post<PostComment[]>(`${this.url}/post-comments/post-comment`, commentValues).map(response => {
        return response.map(comment => new PostComment(comment));
      }).catch(this.handleError)
  }

  editComment(commentValues: Object): Observable<PostComment[]> {
    return this.http
      .post<PostComment[]>(`${this.url}/post-comments/edit-comment`, commentValues).map(response => {
        return response.map(comment => new PostComment(comment));
      }).catch(this.handleError)
  }

  removeComment(id: number): Observable<PostComment[]> {
    return this.http
      .delete<PostComment[]>(`${this.url}/post-comments/remove-comment/${id}`)
      .map(response => {
        return response.map(comment => new PostComment(comment));
      }).catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/providers/post-comment/post-comment.ts